import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../../contexts/useToast';
import { useUpdateSchedulingProfile } from './hooks';
import { SchedulingApiError, SchedulingProfileInput } from './types';

// Shared save logic for the profile settings tabs (field errors + success toast).
export const useProfileSave = (profileId: string) => {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const mutation = useUpdateSchedulingProfile(profileId);
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
  const [formError, setFormError] = useState<string | null>(null);

  const save = async (data: SchedulingProfileInput): Promise<boolean> => {
    setFieldErrors({});
    setFormError(null);
    try {
      await mutation.mutateAsync(data);
      showToast({ type: 'success', message: t('schedulingAdmin.saved') });
      return true;
    } catch (error) {
      if (error instanceof SchedulingApiError) {
        setFieldErrors(error.fieldErrors);
        setFormError(
          error.nonFieldErrors[0] ?? (Object.keys(error.fieldErrors).length ? null : error.message)
        );
      } else {
        setFormError(t('schedulingAdmin.errors.generic'));
      }
      return false;
    }
  };

  return { save, isSaving: mutation.isPending, fieldErrors, formError };
};
